import { jsx as _jsx } from "react/jsx-runtime";
import EmployeeForm from './form';
/**
 * Add New Employee Page
 */
export default function NewEmployee() {
    return _jsx(EmployeeForm, { mode: "create" });
}
